import PropTypes from 'prop-types';
import React from 'react';

import Card from '../Card';

import './styles.scss';

const componentBaseClass = 'qoc-card-splash';

/* Helper Functions */
function renderSteps(targetProps = {}) {
  const { stepCountCurrent, stepCountMax } = targetProps;

  if (stepCountMax) {
    return (
      <div className={`${componentBaseClass}__steps`}>
        Step {stepCountCurrent} of {stepCountMax}
      </div>
    );
  }

  return null;
}
/* /Helper Functions */

function CardSplash(props = {}) {
  const { children, stepCountCurrent, stepCountMax, subTitle, title } = props;

  return (
    <div className={componentBaseClass}>
      <Card>
        {renderSteps({ stepCountCurrent, stepCountMax })}
        {title && (
          <div
            className={`${componentBaseClass}__title${
              stepCountMax ? 'steps' : ''
            }`}
          >
            {title}
          </div>
        )}
        {subTitle && (
          <div className={`${componentBaseClass}__sub-title`}>{subTitle}</div>
        )}
        {children}
      </Card>
    </div>
  );
}

CardSplash.propTypes = {
  children: PropTypes.node,
  stepCountCurrent: PropTypes.number,
  stepCountMax: PropTypes.number,
  subTitle: PropTypes.node,
  title: PropTypes.node
};

CardSplash.defaultProps = {
  children: null,
  stepCountCurrent: 0,
  stepCountMax: 0,
  subTitle: null,
  title: null
};

export default CardSplash;
